import React from "react"
import styled from "styled-components"
import errorImage from "content/images/error.svg"
import emptyImage from "content/images/empty.svg"


const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    font-style: normal;
    font-weight: normal;
    font-size: 1rem;
    line-height: 1.1764rem;
    text-align: center;
    color: #6485A8;
    margin-bottom: 0.5rem;
  }
  img {
    height: ${props => props.min ? '7.76424rem' : ''};
    margin-top: ${props => props.min ? '-1.5rem' : ''};
  }
  .subtitle {
    ont-style: normal;
    font-weight: normal;
    font-size: 0.82348rem;
    line-height: 1.1764rem;
    text-align: center;
    color: #9DB9D6;
  }
`

const ErrorMessage = ({title, subtitle, type, min}) => {
  return (
    <StyledContainer min={min}>
      <img src={type === 'empty' ? emptyImage : errorImage} alt="error" />
      <div className="title">{title}</div>
      <div className="subtitle">{subtitle}</div>
    </StyledContainer>
  )
}

export default ErrorMessage;